import { render, staticRenderFns } from "./BrandView.vue?vue&type=template&id=daa5b9b8&scoped=true"
import script from "./BrandView.vue?vue&type=script&lang=js"
export * from "./BrandView.vue?vue&type=script&lang=js"
import style0 from "./BrandView.vue?vue&type=style&index=0&id=daa5b9b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa5b9b8",
  null
  
)

export default component.exports